/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const publishedChallengeSlugSchema = z.object({
  id: z.number(),
  slug: z.string(),
  updatedAt: z.number(),
});

export type IPublishedChallengeSlugItem = z.infer<typeof publishedChallengeSlugSchema>;

export const listPublicChallengeSlugsV2ResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(publishedChallengeSlugSchema),
  pagination: z.object({
    nextCursor: z.string().nullable(),
    hasMore: z.boolean(),
  }),
});

export type IListPublicChallengeSlugsV2Response = z.infer<
  typeof listPublicChallengeSlugsV2ResponseSchema
>;
